/** Copyright (c) 2017-present, Trend Micro, Inc. All rights reserved. */
import { configureStore } from "@reduxjs/toolkit";

import cloudOneReducer, { CloudOneState } from "./cloud-one";

export interface RootState {
  cloudOne: CloudOneState;
}

export const storeInstance = configureStore({
  reducer: {
    cloudOne: cloudOneReducer,
  },
});
